export const themes = {
  pink: {
    name: 'Современный минимализм',
    colors: {
      primary: '#1f2937',
      secondary: '#f9fafb',
      accent: '#d1d5db',
      background: '#ffffff',
      surface: '#ffffff',
      text: '#1f2937',
      textSecondary: '#6b7280',
      border: '#e5e7eb',
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      gradient: 'linear-gradient(135deg, #1f2937, #374151)',
      glass: 'rgba(255, 255, 255, 0.8)',
      glassBorder: 'rgba(229, 231, 235, 0.5)'
    }
  },
  purple: {
    name: 'Пыльные тона',
    colors: {
      primary: '#8b7355',
      secondary: '#f8f7f6',
      accent: '#d6c7b8',
      background: '#ffffff',
      surface: '#ffffff',
      text: '#4a4338',
      textSecondary: '#8b7355',
      border: '#e8e4e0',
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      gradient: 'linear-gradient(135deg, #8b7355, #a68b5b)',
      glass: 'rgba(248, 247, 246, 0.8)',
      glassBorder: 'rgba(232, 228, 224, 0.5)'
    }
  },
  blue: {
    name: 'Светло-болотный',
    colors: {
      primary: '#6b7280',
      secondary: '#f0fdf4',
      accent: '#bbf7d0',
      background: '#ffffff',
      surface: '#ffffff',
      text: '#1f2937',
      textSecondary: '#6b7280',
      border: '#d1fae5',
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      gradient: 'linear-gradient(135deg, #6b7280, #9ca3af)',
      glass: 'rgba(240, 253, 244, 0.8)',
      glassBorder: 'rgba(209, 250, 229, 0.5)'
    }
  }
};

export const animations = {
  bounce: 'bounce 2s infinite',
  pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
  spin: 'spin 1s linear infinite',
  wiggle: 'wiggle 1s ease-in-out infinite',
  float: 'float 3s ease-in-out infinite',
  glow: 'glow 2s ease-in-out infinite alternate'
};

export const glassmorphism = {
  backdrop: 'backdrop-filter: blur(20px) saturate(180%)',
  background: '#FFFFFF',
  border: '1px solid #B8E6C1',
  shadow: '0 8px 32px 0 rgba(119, 253, 144, 0.15)'
};

export const avatars = [
  '👩‍💼', '👩‍🎨', '👩‍🔬', '👩‍⚕️', '👩‍🏫', '👩‍💻', '👩‍🎤', '👩‍🚀',
  '🧑‍💼', '🧑‍🎨', '🧑‍🔬', '🧑‍⚕️', '🧑‍🏫', '🧑‍💻', '🧑‍🎤', '🧑‍🚀',
  '👸', '🧚‍♀️', '🧜‍♀️', '🧝‍♀️', '🦸‍♀️', '🧙‍♀️', '👩‍❤️‍👩', '👩‍❤️‍💋‍👩'
];

export const stickers = {
  emotions: ['😊', '😍', '🥰', '😘', '😉', '😋', '🤗', '😌', '😇', '🥳', '🤩', '😎', '🤔', '😏', '😅', '😂'],
  activities: ['💪', '🏃‍♀️', '🧘‍♀️', '📚', '✍️', '🎨', '🎵', '🍳', '🛍️', '💄', '💅', '🌸', '🦋', '⭐', '💫', '🌈'],
  achievements: ['🏆', '🥇', '🎯', '💎', '👑', '🌟', '✨', '🎊', '🎉', '💝', '🎁', '❤️', '💖', '💕', '💗', '💓']
};
